﻿const navGroups = [
  {
    title: "サービス",
    links: [
      { label: "エンジニアリングサービス", href: "#services" },
      { label: "フィールドサービス", href: "#services" },
    ],
  },
  {
    title: "会社情報",
    links: [
      { label: "会社紹介", href: "#about" },
      { label: "会社概要", href: "#company" },
      { label: "採用情報", href: "#recruit" },
    ],
  },
  {
    title: "お問い合わせ",
    links: [
      { label: "お問い合わせフォーム", href: "#contact" },
    ],
  },
];

const handleScroll = (href: string) => {
  const el = document.querySelector(href);
  if (el) {
    const top = el.getBoundingClientRect().top + window.scrollY - 72;
    window.scrollTo({ top, behavior: "smooth" });
  }
};

export default function Footer() {
  return (
    <footer
      className="relative overflow-hidden"
      style={{ background: "linear-gradient(180deg, #071530 0%, #030e22 100%)" }}
    >
      <div className="absolute top-0 left-0 right-0 h-px section-divider" />

      {/* Main footer content */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-12">
          {/* Brand column */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <img
                  src="/iNeXX07.png"
                  alt="iNeXX logo"
                  className="w-8 h-8 object-contain"
                />
              </div>
              <span className="text-white font-bold text-lg tracking-wider">
                株式会社<span className="text-inexx-blue">iNeXX</span>
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6 max-w-xs">
              移動体通信ソリューション事業支援
            </p>
            {/* Social icons */}
            <div className="flex items-center gap-3">
              {[
                { icon: "ri-twitter-x-line", href: "#" },
                { icon: "ri-linkedin-line", href: "#" },
                { icon: "ri-facebook-circle-line", href: "#" },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                  className="w-9 h-9 flex items-center justify-center rounded-full text-gray-400 hover:text-white hover:bg-inexx-blue/30 transition-all duration-200 cursor-pointer"
                  style={{ border: "1px solid rgba(0,119,204,0.25)" }}
                >
                  <i className={`${s.icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Nav columns */}
          {navGroups.map((group) => (
            <div key={group.title}>
              <h4 className="text-white font-semibold text-sm mb-4">{group.title}</h4>
              <ul className="flex flex-col gap-2">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); handleScroll(link.href); }}
                      className="text-gray-400 hover:text-inexx-blue-light text-sm transition-colors duration-200 cursor-pointer flex items-center gap-1.5 group"
                    >
                      <span className="w-0 group-hover:w-3 h-0.5 bg-inexx-blue transition-all duration-200 overflow-hidden" />
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="h-px w-full bg-white/5 mb-6" />

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-xs">
            © 2025 株式会社iNeXX. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            {["プライバシーポリシー", "利用規約"].map((item) => (
              <a
                key={item}
                href="#"
                rel="nofollow"
                className="text-gray-500 hover:text-gray-300 text-xs transition-colors duration-200 cursor-pointer"
              >
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
